<div class="tabs-container">
  <button class="tab" [ngClass]="activeTab == tab.value ? 'active-tab' : 'inactive-tab'"
    *ngFor="let tab of tabs" (click)="tabClick(tab.value)">
    {{tab.label}}
</button>
</div>